import request from '@/utils/request'
/**
 *
 * 赛事直播管理
 *
 **/

// 获取列表接口
export const getLiveStreamingList = (params: any) => {
  return request({
    url: '/liveStreaming/page',
    method: 'get',
    params
  })
}

// 修改---启用禁用接口
export const enableOrDisableLiveStreaming = (params: any) => {
  return request({
    url: `/liveStreaming/status/${params.status}`,
    method: 'post',
    params: { id:params.id,type: params.type }
  })
}

// 新增---新建赛事直播
export const addLiveStreaming = (params: any) => {
  return request({
    url: '/liveStreaming',
    method: 'post',
    data: { ...params }
  })
}

// 修改---新建赛事直播
export const updateLiveStreaming = (params: any) => {
  return request({
    url: '/liveStreaming',
    method: 'put',
    data: { ...params }
  })
}

// 修改页面反查详情接口
export const queryGiftLiveStreaming = (id: string | (string | null)[]) => {
  return request({
    url: `/liveStreaming/${id}`,
    method: 'get'
  })
}

// 删除接口
export const deleteLiveStreaming = (params) => {
  return request({
    url: '/liveStreaming',
    method: 'delete',
    params: { ids:params.ids}
  })
}
